import React from "react";
import Loadable from "../../react-loadable";

import "./index.less";

const WeaMap = Loadable({
  loader: () => import("./Main"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

export default WeaMap;



// WEBPACK FOOTER //
// ./ecology9/wea-map/index.js